import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import {
  EMPTY_TO_MANY,
  EMPTY_TO_ONE,
  linkageFromResource,
} from '@opallabs/json-api'
import { userResourceFactory } from './user'
import { viewResourceFactory } from './view'

type CategoryResourceV3 = OpalApiComponent<'V3', 'category'>

export const categoryResourceFactory: Factory<CategoryResourceV3> =
  Factory.define<CategoryResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'category',
      attributes: {
        block_size: 'medium',
        view_mode: 'default',
        created_at: new Date().toISOString(),
        depth: 0,
        group_by_exclude_empty_groupings: false,
        group_by_strategy: null,
        position: 0,
        title: `Mock Category ${sequence}`,
        updated_at: new Date().toISOString(),
        is_supportive: false,
      },
      relationships: {
        block_connectors: EMPTY_TO_MANY,
        blocks: EMPTY_TO_MANY,
        category_type: EMPTY_TO_ONE,
        charts: EMPTY_TO_MANY,
        creator: linkageFromResource(userResourceFactory.build()),
        group_by_custom_field: EMPTY_TO_ONE,
        parent_category: EMPTY_TO_ONE,
        view: linkageFromResource(viewResourceFactory.build()),
      },
    } satisfies CategoryResourceV3
  })
